import { Link, type LinkProps } from 'react-router'
import { cn } from '@/helpers/utils'
import { BrandGradientOverlay } from './brand-gradient-overlay'
import { buttonVariants } from './button'
import type { ButtonStyleProps } from './button-brand'

export type ButtonLinkBrandProps = LinkProps &
	ButtonStyleProps & {
		disabled?: boolean
		ref?: React.Ref<HTMLAnchorElement>
	}

function ButtonLinkBrand({
	shape = 'rectangle',
	size = 'md',
	className,
	children,
	disabled,
	ref,
	...props
}: ButtonLinkBrandProps) {
	return (
		<Link
			aria-disabled={disabled}
			className={buttonVariants({
				variant: 'brand',
				size,
				shape,
				className: cn('group', className, disabled && 'disabled')
			})}
			data-slot='button'
			onClick={(event) => {
				if (disabled) {
					event.preventDefault()
					event.stopPropagation()
				} else {
					props.onClick?.(event)
				}
			}}
			ref={ref}
			tabIndex={disabled ? -1 : undefined}
			{...props}
		>
			<BrandGradientOverlay />
			<span className='relative z-2 flex items-center justify-center'>
				{children}
			</span>
		</Link>
	)
}

export { ButtonLinkBrand }
